import React, { useState } from 'react';
import { format } from 'date-fns';
import { Button } from '@/components/ui/button';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Calendar, Clock, MapPin } from 'lucide-react';
import InspectionResponseModal from './InspectionResponseModal';

const InspectionCard = ({ inspection }) => {
   const [showResponseModal, setShowResponseModal] = useState(false);

   const getStatusColor = (status) => {
      const colors = {
         'Pending': 'bg-yellow-100 text-yellow-800 border-yellow-200',
         'Accepted': 'bg-green-100 text-green-800 border-green-200',
         'Completed': 'bg-blue-100 text-blue-800 border-blue-200',
         'Reschedule Requested': 'bg-orange-100 text-orange-800 border-orange-200',
         'New Schedule Proposed': 'bg-purple-100 text-purple-800 border-purple-200'
      };
      return colors[status] || 'bg-gray-100 text-gray-800 border-gray-200';
   };

   const renderActionButton = () => {
      if (inspection.inspectionStatus === 'Pending') {
         return (
            <Button
               onClick={() => setShowResponseModal(true)}
               size="sm"
               className="bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white"
            >
               Respond to Schedule
            </Button>
         );
      }

      if (inspection.inspectionStatus === 'New Schedule Proposed') {
         return (
            <Button onClick={() => setShowResponseModal(true)} size="sm">
               Respond to New Schedule
            </Button>
         );
      }

      return null;
   };

   return (
      <Card className="hover:shadow-md transition-shadow">
         <CardHeader className="pb-2">
            <div className="flex justify-between items-start gap-4">
               <div>
                  <CardTitle className="text-base font-semibold">
                     {inspection.applicationNumber}
                  </CardTitle>
                  <p className="text-sm text-muted-foreground">
                     {inspection.applicationType}
                  </p>
               </div>
               <Badge
                  variant="outline"
                  className={`${getStatusColor(inspection.inspectionStatus)} whitespace-nowrap`}
               >
                  {inspection.inspectionStatus}
               </Badge>
            </div>
         </CardHeader>
         <CardContent className="pb-4">
            <div className="space-y-3">
               <div className="space-y-2 text-sm">
                  <div className="flex items-center gap-2">
                     <Calendar className="h-4 w-4 text-muted-foreground shrink-0" />
                     <span>{format(new Date(inspection.scheduledDate), 'PPP')}</span>
                     <span className="text-muted-foreground">at</span>
                     <span>{inspection.scheduledTime}</span>
                  </div>
                  <div className="flex items-center gap-2">
                     <MapPin className="h-4 w-4 text-muted-foreground shrink-0" />
                     <span>{inspection.location}</span>
                  </div>
               </div>

               <div className="flex justify-end">
                  {renderActionButton()}
               </div>
            </div>

            <InspectionResponseModal
               isOpen={showResponseModal}
               onClose={() => setShowResponseModal(false)}
               inspection={inspection}
            />
         </CardContent>
      </Card>
   );
};

export default InspectionCard;
